var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3DShapeObject(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h24v24h-24Z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.0711,9.17157c3.90524,1.5621 3.90524,4.09476 0,5.65685c-3.90524,1.5621 -10.2369,1.5621 -14.1421,0c-3.90524,-1.5621 -3.90524,-4.09476 -1.77636e-15,-5.65685c3.90524,-1.5621 10.2369,-1.5621 14.1421,-1.77636e-15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M14.8284,4.92893c1.5621,3.90524 1.5621,10.2369 0,14.1421c-1.5621,3.90524 -4.09476,3.90524 -5.65685,0c-1.5621,-3.90524 -1.5621,-10.2369 -1.77636e-15,-14.1421c1.5621,-3.90524 4.09476,-3.90524 5.65685,-1.77636e-15"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#323232",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M19.0711,4.92893c3.90524,3.90524 3.90524,10.2369 0,14.1421c-3.90524,3.90524 -10.2369,3.90524 -14.1421,0c-3.90524,-3.90524 -3.90524,-10.2369 -1.77636e-15,-14.1421c3.90524,-3.90524 10.2369,-3.90524 14.1421,-1.77636e-15"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3DShapeObject);
export default __webpack_public_path__ + "static/media/3D-Shape-Object.7e636901cd5704a1d98d2b5206413a2f.svg";
export { ForwardRef as ReactComponent };